// src/theme.js
import { createTheme } from "@mui/material/styles";

export function createAppTheme(mode) {
  return createTheme({
    palette: {
      mode,
      ...(mode === "light"
        ? {
            background: {
              default: "#8fb9a8", // body / tracker backdrop
              paper: "#ffffff",
              page: "#f5f5f5",   // settings-style page wrappers
              card: "#fefad4",   // content cards (log entries, charts)
            },
            logout: { main: "#fff" },
          }
        : {
            background: {
              default: "#1a2420", // body / tracker backdrop (dark teal)
              paper: "#1e1e1e",
              page: "#121212",   // settings-style page wrappers
              card: "#2a2a1e",   // content cards — dark warm tone
            },
            primary: { main: "#9575CD" },
            logout: { main: "#fff" },
          }),
    },
    typography: {
      fontFamily: "'Fredoka', sans-serif",
    },
  });
}

// Keep a default export for backwards-compatibility (used nowhere now, but safe)
export default createAppTheme("light");
